import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { bindActionCreators } from 'redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { connect } from 'react-redux';
import notificationPopUp from '../../../NotificationPopUp';

import commonFunctions from '../../../commonFunctions';

import CheckboxInput from '../../common/checkBox/CheckboxInput';
import ConfirmationModal from '../../common/ConfirmationModal';
import TextInput from '../../common/TextInput';
import TooltipFormatter from '../../common/TooltipFormatter';

import * as authenticationActions from '../../../actions/authenticationActions';
import * as tariffActions from '../../../actions/tariffActions';

class TariffsPage extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      authenticationState: this.props.authenticationState,
      commonState: this.props.commonState,
      pagingModel: this.props.pagingModel,
      tariffDeleteModal: {
        show: false,
        dropRowKeysp: []
      }
    };

    if (!authenticationActions.verifyAuthentication(this.state.authenticationState, this.props.history)) {
      return;
    }
  }

  componentDidMount() {
    this.search();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.authenticationState !== prevState.authenticationState || nextProps.commonState !== prevState.commonState ||
      nextProps.pagingModel !== prevState.pagingModel) {
      const appPaginModel = Object.assign({}, prevState.pagingModel,
        {
          items: nextProps.pagingModel.items,
          page: nextProps.pagingModel.page,
          itemsPerPage: nextProps.pagingModel.itemsPerPage,
          total: nextProps.pagingModel.total
        });
      return Object.assign({}, prevState, { authenticationState: nextProps.authenticationState, commonState: nextProps.commonState, pagingModel: appPaginModel });
    }
    return null;
  }

  gridAnnualNetValue = (cell, row) => {
    return (
      <div>{commonFunctions.numberToItalianEuroFormat(cell)}</div>
    );
  }

  gridOnRowClick = (row) => {
    this.props.history.push('tariff/' + row.id);
  }

  closedFormat = (cell, row) => {
    if (cell)
      return 'CHIUSO';
    return 'APERTO';
  }

  lockedOutFormat = (cell, row) => {
    if (cell)
      return 'NON MODIFICABILE';
    return 'MODIFICABILE';
  }

  onPageChange = (page, sizePerPage) => {
    var nPaging = Object.assign({}, this.state.pagingModel, { page: page, itemsPerPage: sizePerPage });
    this.search(nPaging);
  }

  onSortChange = (sortName, sortOrder) => {
    var nPaging = Object.assign({}, this.state.pagingModel, { sortName: sortName, sortOrder: sortOrder });
    this.search(nPaging);
  }

  redirectToTariffPage = () => {
    this.props.history.push('tariff');
  }

  rowClassNameFormat = (row, rowIdx) => {
    if (row.closed)
      return 'redRow';

    return rowIdx % 2 === 0 ? 'grayRow' : 'whiteRow';
  }

  search = (nPaging) => {
    if (!nPaging)
      nPaging = this.state.pagingModel;

    this.props.actions.loadTariffs(nPaging).then(() => {
    }).catch(error => {
      notificationPopUp.error('Problemi nel caricamento dei dati');
    });
  }

  showHideTariffDeleteModal = (dropRowKeys) => {
    const tariffDeleteModal = Object.assign({}, this.state.tariffDeleteModal);
    tariffDeleteModal.show = !tariffDeleteModal.show;
    tariffDeleteModal.dropRowKeysp = dropRowKeys;
    this.setState(Object.assign({}, this.state, { tariffDeleteModal }));
  }

  tariffInsertButton = () => {
    return (<button type="button" className="btn btn-info react-bs-table-add-btn" onClick={this.redirectToTariffPage}>
      <span><i className="glyphicon glyphicon-plus"></i>Aggiungi</span>
    </button>);
  }

  tariffDelete = (ids) => {
    this.props.actions.deleteTariff(ids[0]).then(() => {
      notificationPopUp.success('Piano Mutualistico Eliminato');
      this.showHideTariffDeleteModal([]);
    }).catch(error => {
      notificationPopUp.error(error);
    });
  }

  tariffConfirmDelete = (next, dropRowKeys) => {
    this.showHideTariffDeleteModal(dropRowKeys);
  }

  tooltipFormatter = (cell, row) => {
    return (
      <TooltipFormatter text={cell} tooltip={cell} placement="top" />
    );
  }

  updateFilters = (event) => {
    const pagingModel = Object.assign({}, this.state.pagingModel);
    pagingModel[event.target.name] = event.target.value;
    this.setState(Object.assign({}, this.state, { pagingModel }));
  }

  render() {
    const gridOptions = {
      sizePerPage: this.state.pagingModel.itemsPerPage,
      page: this.state.pagingModel.page,
      sizePerPageList: [5, 10, 20, 50],
      onRowClick: this.gridOnRowClick,
      onPageChange: this.onPageChange,
      onSortChange: this.onSortChange,
      insertBtn: this.tariffInsertButton,
      deleteText: 'Elimina',
      handleConfirmDeleteRow: this.tariffConfirmDelete
    };

    return (
      <div className='container-fluid'>
        <h1>Gestione Piani Mutualistici</h1>
        <div className="row panel panel-default x-panel-gray">
          <div className="panel-heading">Filtri</div>
          <div className="panel-body">
            <Row>
              <Col xs={12} md={4}>
                <TextInput
                  label='Nome'
                  name='label'
                  onChange={this.updateFilters}
                  value={this.state.pagingModel.label} />
              </Col>
              <Col xs={12} md={4}>
                <TextInput
                  label='Codice'
                  name='code'
                  onChange={this.updateFilters}
                  value={this.state.pagingModel.code} />
              </Col>
              <Col xs={12} md={4}>
                <CheckboxInput
                  label='Mostra Piani Chiusi'
                  labelStyle={{ width: '200px!important' }}
                  name='showClosed'
                  onChange={this.updateFilters}
                  overrideCheckboxLabel={true}
                  value={this.state.pagingModel.showClosed} />
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Button bsStyle='primary' onClick={() => this.search(Object.assign({}, this.state.pagingModel, { page: 1 }))} >Cerca</Button>
              </Col>
            </Row>
          </div>
        </div>
        <div className="row">
          <BootstrapTable data={this.state.pagingModel.items} fetchInfo={{ dataTotalSize: this.state.pagingModel.total }} options={gridOptions}
            trClassName={this.rowClassNameFormat} insertRow={true} selectRow={{ mode: 'radio' }} deleteRow remote hover pagination>
            <TableHeaderColumn isKey dataField='id' hidden>Id</TableHeaderColumn>
            <TableHeaderColumn dataField='label' width={'40%'} dataSort dataFormat={this.tooltipFormatter}>Denominazione</TableHeaderColumn>
            <TableHeaderColumn dataField='code' width={'15%'} dataSort>Codice</TableHeaderColumn>
            <TableHeaderColumn dataField='annualNetValue' width={'15%'} dataFormat={this.gridAnnualNetValue}>Valore Netto</TableHeaderColumn>
            <TableHeaderColumn dataField='lockedOut' width={'15%'} dataFormat={this.lockedOutFormat} dataSort>Modificabile</TableHeaderColumn>
            <TableHeaderColumn dataField='closed' width={'15%'} dataFormat={this.closedFormat}>Stato</TableHeaderColumn>
          </BootstrapTable>
        </div>
        <ConfirmationModal
          title='Conferma Eliminazione Piano Mutualistico'
          message={'Sei sicuro di voler eliminare il Piano Mutualistico selezionato?'}
          show={this.state.tariffDeleteModal.show}
          showHide={this.showHideTariffDeleteModal}
          action={() => this.tariffDelete(this.state.tariffDeleteModal.dropRowKeysp)}
          commonState={this.state.commonState} />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    authenticationState: state.authenticationState,
    commonState: state.commonState,
    pagingModel: state.tariffState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(tariffActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TariffsPage);
